module.exports = __webpack_public_path__ + "img/HRDC.41d4d8d4.png";